<template>
    <div class="store-page page safe-page ">
        <div class="p-20px">

            <div class="sticky top-0px z-100 bg-#01031B ">
                <div class="flex items-center justify-between pb-10px">
                    <div class="flex header-round rounded-10 py-2px px-5px pr-7px! items-center justify-center">
                        <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px mr-5px mt-1px"></img>
                        <div class="text-14px font-500 color-#fff">
                            {{ userStore.msgCost }}
                        </div>
                        <!-- <img src="@/assets/images/home/add.svg" class="w-20px h-20px ml-5px"></img> -->
                    </div>
                    <div class="cursor-pointer" @click="handleClosePopup">
                        <img src="@/assets/images/message/close.svg" alt="" class="w-24px h-24px">
                    </div>
                </div>
                <!-- <div class="store-tab color-#fff flex">
                    <div class="store-tab-item" @click="handleTabClick(0)" :class="{ 'active': activeTab === 0 }">
                        Store
                    </div>
                    <div class="store-tab-item" @click="handleTabClick(1)" :class="{ 'active': activeTab === 1 }">
                        Record
                    </div>
                </div> -->
                <!-- </div> -->
            </div>
            <!-- <div v-if="true" class="flex justify-between items-center">
                <div class="vip-text">
                    Become a VIP with any Purchase
                </div>
                <div class="w-32px flex items-center justify-center">
                    <img src="@/assets/images/store/vip.webp" alt="" class="w-100% h-100%">
                </div>
            </div> -->
            <div class="store-title" v-if="true">
                *If the recharge fails, Please
                <span @click="handleContactUs">contact us ></span>
            </div>
            <!-- 支付渠道切换 -->
            <!-- <div class="flex items-center gap-12px mb-10px" v-if="gemItems.length && activeTab === 0">
                <div class="w-69px h-32px flex items-center justify-center rounded-10px bg-#13162B"
                    v-for="(channel, cIdx) in gemItems" :key="channel.channel || cIdx" @click="tabChannelClick(cIdx)">
                    <img :src="cIdx === selectedChannelIndex ? channel.icon?.selected : channel.icon?.unSelected"
                        class="w-90px h-32px" />
                </div>
            </div> -->
        </div>
        <div class="w-100% h-86px mb-20px" @click="gotoVipPage">
            <img src="@/assets/images/store/banner.svg" alt="" class="w-100% h-100%">
        </div>
        <div v-if="true" class="store-content-box ">
            <div class="store-content overflow-y-auto px-20px">
                <div class="store-item relative" :class="item.limitBuy === 1 ? 'active-item' : ''"
                    v-for="(item, index) in gemItems[selectedChannelIndex]?.list" :key="item.id || index"
                    @click="handleItemClick(gemItems[selectedChannelIndex], index)">
                    <!-- 折扣率 -->
                    <div v-if="calculateDiscountRate(item.price, item.originalPrice || 0)">
                        <!-- <div class="item-off w-66px absolute top-0px left--8px" v-if="isShowActiveItemText(index)">
                            <img src="@/assets/images/store/off.webp" alt="" class="w-66px absolute top-0 left-0"></img>
                            <div class="text-10px font-500 color-#fff font-600 absolute top-7px left-6px">
                                {{ calculateDiscountRate(item.price, item.originalPrice || 0) }}% OFF
                            </div>
                        </div>
                        <div class="item-dwon w-66px absolute top-0px left--8px" v-else>
                            <img src="@/assets/images/store/down.webp" alt=""
                                class="w-66px absolute top-0 left-0"></img>
                            <div class="text-10px font-500 color-#fff absolute top-7px left-5px">
                                {{ calculateDiscountRate(item.price, item.originalPrice || 0) }}% OFF
                            </div>
                        </div> -->
                        <div class="item-off w-66px absolute top-0px left--8px">
                            <img src="@/assets/images/store/off.webp" alt="" class="w-66px absolute top-0 left-0"></img>
                            <div class="text-10px font-500 color-#fff font-600 absolute top-7px left-10px">
                                {{ t('store.popular') }}
                            </div>
                        </div>
                    </div>
                    <div v-if="item.giftAmount"
                        class="item-dwon gift-bg w-48px h-48px absolute top--5px right--5px flex-col items-center justify-center transform rotate-20deg">
                        <!-- <img src="@/assets/images/store/gift.webp" alt="" class="w-48px absolute top-0 left-0"></img> -->
                        <div class="gift-text w-48px  font-500 color-#fff  flex flex-col items-center">
                            <div class="text-10px color-#CF00FF font-600 gigt">{{ t('store.gift') }}</div>
                            <div class="text-10px color-#CF00FF ">
                                {{ item.giftAmount }}
                            </div>
                        </div>
                    </div>
                    <div class="item-img ">
                        <img :src="item.image" alt="" class="w-100% h-100%">
                    </div>
                    <div class="item-info-box">
                        <div class="item-info flex items-center justify-center">
                            <div class="w-13px mb-2px">
                                <img src="@/assets/images/home/crystal.webp" alt="" class="w-100% h-100%">
                            </div>
                            <div class="item-info-price color-#fff text-14px font-900">
                                {{ item.amount }}
                            </div>
                        </div>
                        <div class="text-10px color-#fff font-500 text-center active-item-text"
                            v-if="item.limitBuy === 1">One
                            time only</div>

                        <div class="item-btn flex items-center justify-center"
                            :class="item.limitBuy === 1 ? 'active-item-btn' : ''">
                            <div class="gem-price-original text-10px line-through"
                                v-if="item.originalPrice !== item.price && item.originalPrice !== 0">
                                ${{ Number(item.originalPrice) / 100 }}
                            </div>
                            <div class="gem-price ml-3px mt-2px">${{ Number(item.price) / 100 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <popupSlide v-model:showPopup="showPopup" />

        <!-- 挽留弹窗 -->
        <Transition name="retention-popup">
            <div v-if="showRetentionPopup" class="retention-popup-overlay"
                @click.self="() => { showRetentionPopup = false, logEventSafe('re_retention_popup_click_close') }">
                <div class="retention-popup-wrapper">
                    <div class="retention-popup-container">
                        <!-- 角色头像区域 -->
                        <div class="retention-avatar-wrapper relative pt-20px">
                            <div class="w-full h-114px absolute top-0 left-0">
                                <div class="">
                                    <img src="@/assets/images/vip/stay_store.webp" alt="" class="w-100% h-100%"></img>
                                </div>
                            </div>
                            <div class="w-86px h-86px relative y-center">
                                <div class="retention-avatar-circle ">
                                    <img :src="currentCharacterAvatar" alt="" class="retention-avatar-img">
                                </div>
                            </div>
                            <div class="retention-kiss-emoji">
                                <img src="@/assets/images/vip/stay_store_kiss.webp" alt="" class="w-32px h-30px"></img>
                            </div>
                        </div>

                        <!-- 文本内容 -->
                        <div class="retention-text">
                            {{ t('store.retentionMessage') }}
                        </div>

                        <!-- 按钮组 -->
                        <div class="retention-actions">
                            <div class="retention-btn-primary" @click="handleBuyNow">
                                {{ t('firstCharge.buyNow') }}
                            </div>
                            <div class="retention-btn-secondary" @click="handleCloseRetention">
                                {{ t('firstCharge.maybeLater') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts" name="storePage">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { onMounted, computed, ref } from 'vue'
import { useStorePageStore } from '@/stores/store'
import { useChatStore } from '@/stores/chat'
import theme from '@/styles/theme'
import bridge from '@/utils/bridge'
import { logEventSafe } from "@/plugins/firebase";
import popupSlide from '@/views/home/com/FirstChargePopUp.vue'
import { closeToast } from '@/utils/toast'
import { getCheckOrderStatus } from '@/views/store/index'
import { showLoadingToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const userInfo = computed(() => userStore.getTouristInfo())
const storePageStore = useStorePageStore()
const chatStore = useChatStore()
const userStore = useUserStore()
const showPopup = ref(false)
const router = useRouter()
const selectedChannelIndex = ref(0)
const showRetentionPopup = ref(false)
const userData = computed(() => JSON.parse(localStorage.getItem('ai-chat-user') || '{}'))

// 获取当前角色信息
const currentCharacterAvatar = computed(() => {
    const currentDigitalHuman = chatStore.currentDigitalHuman
    return currentDigitalHuman?.avatar || '/assets/images/discover/dome.png'
})

const props = defineProps({
    handleClose: {
        type: Function,
        required: true
    },
    isShowStayPopup: {
        type: Boolean,
        default: true
    }
})

// 使用store的状态和方法
const activeTab = computed({
    get: () => storePageStore.activeTab,
    set: (value: number) => storePageStore.switchTab(value)
})

const gemItems = computed(() => storePageStore.rechargeItems)


/**
 * 计算折扣率
 */
const calculateDiscountRate = (price: number, originalPrice: number): number => {
    return storePageStore.calculateDiscountRate(price, originalPrice)
}

const gotoVipPage = () => {
    router.push({
        path: '/vip',
        query: {
            type: 'u',
            tab: 'chat'
        }
    })
}

/**
 * 处理充值商品点击
 */
const handleItemClick = async (item: any, index: number) => {
    localStorage.setItem('is_store_popup', '1');
    localStorage.setItem('nowMsgCost', String(userStore.msgCost))
    bridge.callApp('inAppPayLoad', {
        item: item.list[index],
        url: '/applePurchase'
    })
    if (localStorage.getItem('first_pay_success_to_vippage') !== '1') {
        logEventSafe('first_pay_success_to_store_show_up');
    }
    logEventSafe('storepopup_pricebutton_click');
}

const tabChannelClick = (index: number) => {
    selectedChannelIndex.value = index
    localStorage.setItem('selectedChannelIndex', String(index))
}


/**
 * 处理联系我们
*/
const handleContactUs = () => {
    showLoadingToast(t('dialog.processing'),{duration: 2000})
    window.location.href = userData.value.reportLost || 'https://forms.gle/6c5dh2JpfbEcZfST8'
}

/**
 * 处理关闭弹窗
 */
const handleClosePopup = () => {
    if (props.isShowStayPopup) {
        logEventSafe('re_retention_popup_show')
        showRetentionPopup.value = true
    } else {
        props.handleClose()
    }
}

/**
 * 关闭挽留弹窗
 */
const handleCloseRetention = () => {
    logEventSafe('re_retention_popup_click_close')
    showRetentionPopup.value = false
    props.handleClose()
}

/**
 * 立即购买
 */

const recommendedPurchases = computed(() => {
    return gemItems.value[0].list.find((item: any) => item.price === 999)
})
const handleBuyNow = () => {
    logEventSafe('re_retention_popup_click_buy')
    localStorage.setItem('re_retention_popup', 'true')
    showRetentionPopup.value = false
    bridge.callApp('inAppPayLoad', {
        item: recommendedPurchases.value,
        url: '/applePurchase'
    })
}

onMounted(async () => {
    selectedChannelIndex.value = Number(localStorage.getItem('selectedChannelIndex') || 0)
    await getCheckOrderStatus()
    await storePageStore.initialize()
    closeToast()
})
</script>

<style lang="scss" scoped>
.store-page {
    background-color: v-bind('theme.colors.background');
    // overflow-y: auto;

    .store-tab {
        margin-bottom: 10px;
        gap: 30px;

        .store-tab-item {
            font-weight: 900;
            font-size: 16px;
            color: v-bind('theme.colors.textPrimary');

            &.active {
                color: #FFFFFF;
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    background: #FFFFFF;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 10px;
                    height: 2px;
                    background: linear-gradient(270deg, #C489FF 0%, #6868FF 100%);
                    border-radius: 2px;
                }
            }
        }
    }
}

.store-title {
    font-size: 14px;
    color: v-bind('theme.colors.textSecondary');
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 10px;

    span {
        color: #fff;
        font-weight: 700;
    }
}

.store-content-box {
    height: calc(100vh - 250px);
    overflow-y: auto;
}

.store-content {
    overflow: hidden;
    // padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;


    .store-item {
        width: calc(33.333% - 4px);
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;
        background: RGBA(255, 255, 255, 0.1);
        // padding: 0 px;

        .item-info-box {
            //background-color: RGBA(34, 36, 56, 1);
            width: 100%;
            padding: 0 8px;
            padding-bottom: 10px;
            border-radius: 0 0 10px 10px;
        }

        .item-img {
            width: 64px;
            object-fit: cover;
            // filter: drop-shadow(0 4px 8px rgba(99, 102, 241, 0.3));
            display: flex;
            padding-top: 20px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 8px;
            }
        }

        .item-btn {
            margin-top: 8px;
            width: 100%;
            height: 25px;
            background-color: v-bind('theme.colors.backgroundSecondary');
            border-radius: 10px;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
            background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
            border-radius: 18px;

            .gem-price-original {
                color: v-bind('theme.colors.textPrimary');
            }
        }

        .gift-text {
            line-height: 10px;
            gap: 0;
        }

    }

}

.store-secure {
    font-weight: 500;
    font-size: 12px;
    color: v-bind('theme.colors.textPrimary');
}

.store-consumption-box {
    height: calc(100vh - 170px);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    // 自定义滚动条
    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 2px;

        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    .store-consumption-item {
        margin-bottom: 10px;
        border-radius: 10px;
        background-color: v-bind('theme.colors.backgroundSecondary');

        .store-consumption-item-time {
            font-weight: 500;
            font-size: 12px;
            color: v-bind('theme.colors.textPrimary');
            margin-top: 4px;
        }
    }

    .load-more-section {
        .load-more-btn {
            background: linear-gradient(180deg, #9b75f3 0%, #6026cf 100%);
            color: white;
            border: none;
            border-radius: 20px;
            padding: 10px 30px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: opacity 0.3s ease;

            &:hover {
                opacity: 0.8;
            }

            &:active {
                opacity: 0.6;
            }
        }

        .loading-text {
            color: v-bind('theme.colors.textSecondary');
            font-size: 14px;
            font-weight: 500;
        }

        .loading-spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.2);
            border-top: 2px solid v-bind('theme.colors.textSecondary');
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        .no-more-text {
            color: v-bind('theme.colors.textSecondary');
            font-size: 12px;
            font-weight: 400;
        }
    }

    .empty-state {
        .text-16px {
            font-size: 16px;
            margin-bottom: 10px;
        }

        .text-12px {
            font-size: 12px;
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.gift-bg {
    background-image: url('@/assets/images/store/gift.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}

.active-item {
    border: 1px solid #7546C4 !important;
    // background-color: #1A1C2E;
    background: linear-gradient(180deg, #7546C4 0%, #25093E 100%) !important;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.26), rgba(255, 255, 255, 0.37)) 1 1;
    border: 1px solid;
}

.active-item-btn {
    background: linear-gradient(180deg, #A06EFA 0%, #FA6CCE 100%) !important;
}

.active-item-text {
    position: absolute;
    top: 103px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    background: linear-gradient(0deg, #A06EFA 0%, #FA6CCE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.vip-text {
    font-size: 14px;
    color: #fff;
    font-weight: 700;
    background: linear-gradient(45.00000000000003deg, #F3A14F 0%, #FFEE8D 100%);
    font-style: italic;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.header-round {
    background: rgba(255, 255, 255, 0.2);
}

// 挽留弹窗样式
.retention-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.retention-popup-wrapper {
    width: 100%;
    max-width: 335px;
    position: relative;
}

.retention-popup-container {
    width: 100%;
    border-radius: 20px;
    // padding: 30px 0px;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    overflow: hidden;
    padding-bottom: 15px;
    // 第一层背景
    background: linear-gradient(225deg, #B0C6F8 0%, #B5A7F5 37%, #EBB5EF 100%);

    // 第二层背景（使用伪元素）
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(248, 187, 231, 0) 0%, #FACAD6 100%);
        border-radius: 20px;
        pointer-events: none;
    }

    // 确保内容在背景之上
    >* {
        position: relative;
        z-index: 1;
    }
}

.retention-avatar-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    position: relative;

    .y-center {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.retention-avatar-circle {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    // border: 2px solid #FFB6C1;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
}

.retention-avatar-img {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border-radius: 50%;
}

.retention-kiss-emoji {
    position: absolute;
    top: 20px;
    right: calc(50% - 56px);
    font-size: 20px;
    animation: float 2s ease-in-out infinite;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}

.retention-text {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #01031B;
    line-height: 1.5;
    margin-bottom: 24px;
    padding: 0 10px;
}

.retention-actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
}

.retention-btn-primary {
    width: 80%;
    padding: 10px 20px;
    border-radius: 23px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(90deg, #FFFFFF 0%, #F5F5F5 100%);
    color: #5A68FF;
    box-shadow: 0 4px 12px rgba(90, 104, 255, 0.3);
    background: linear-gradient(180deg, #DAE4F2 0%, #EEEFF7 100%);
    box-shadow: 0px 2px 0px 0px rgba(215, 76, 76, 0.5), inset 0px -2px 5px 0px rgba(255, 255, 255, 0.5);

    &:active {
        opacity: 0.9;
        transform: scale(0.98);
    }


}

.retention-btn-secondary {
    font-size: 14px;
    font-weight: 500;
    // color: #666;
    color: rgba(1, 3, 27, 0.2);
    font-weight: 800;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;

    &:active {
        opacity: 0.7;
    }
}

// 弹窗动画
.retention-popup-enter-active,
.retention-popup-leave-active {
    transition: opacity 0.3s ease;
}

.retention-popup-enter-active .retention-popup-wrapper,
.retention-popup-leave-active .retention-popup-wrapper {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.retention-popup-enter-from {
    opacity: 0;
}

.retention-popup-enter-from .retention-popup-wrapper {
    transform: scale(0.9) translateY(20px);
    opacity: 0;
}

.retention-popup-leave-to {
    opacity: 0;
}

.retention-popup-leave-to .retention-popup-wrapper {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
}
</style>